import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { logoutStaff, selectIsStaffLogged } from "../../redux/staffSlice";

function FooterBar() {
  const dispatch = useDispatch();
  const isStaffLogged = useSelector(selectIsStaffLogged);

  const handleLogout = () => {
    dispatch(logoutStaff());
  };

  return (
    <footer className="w-full bg-[#f7bfd8a2] text-[#F36D26] p-4 flex-col justify-center items-center text-center">
        <div className="justify-around mb-4 sm:flex-col md:flex lg:flex-row xl:flex">
            <div className="mb-4">
                <h2 className="text-lg font-bold mb-2">Contact</h2>
                <a href="mailto:contact@mood-cafe-atelier.com" alt="mail: Contact@mood-cafe-atelier.com">Email: contact@mood-cafe-atelier.com</a>
            </div>
            <div className="mb-4">
                <h2 className="text-lg font-bold mb-2"></h2>
                <a
                  href="https://www.instagram.com/mood_cafe_ceramique"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm inline-flex items-center gap-2 hover:text-orange-800 transition-colors"
                >
                  <svg
                    className="w-5 h-5"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm0 2h10c1.7 0 3 1.3 3 3v10c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3zm11 1a1 1 0 100 2 1 1 0 000-2zM12 7a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6z" />
                  </svg>
                  Instagram
                </a>
            </div>
            <div className="mb-4">
                <h2 className="text-lg font-bold mb-2">Adresse</h2>
                <p className="text-sm">4ter rue d'orange </p>
                <p className="text-sm">37400 Amboise</p>
            </div>
            <div>
                <p className="text-sm font-bold mb-2">
                  <Link to="/cgv" className="text-[#F36D26] hover:text-orange-800 transition-colors">
                    CGV
                  </Link>
                </p>
                {isStaffLogged && (
                  <div className="flex flex-col items-center gap-2">
                    <Link
                      to="/administration"
                      className="px-4 py-2 bg-[#f3a3c7] text-white rounded-lg hover:bg-orange-700 transition"
                    >
                      Administration
                    </Link>
                    <button
                      type="button"
                      onClick={handleLogout}
                      className="px-4 py-2 bg-[#f7bfd8c9] text-white rounded-lg hover:bg-orange-700 transition"
                    >
                      Logout
                    </button>
                  </div>
                )}
            </div>
        </div>
      <p className="text-sm py-4">© 2025 MOOD. All rights reserved.</p>
    </footer>
  );
}

export default FooterBar;
